// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IEnvironment } from './environmentType';
import { IntegrationEnvironment }  from './environment.int';
/**
 * Dev environment settings
 * */
export class DevEnvironment {
    static getConfiguration(): IEnvironment {
        return {
            ...IntegrationEnvironment.getConfiguration(),
            hostname: 'https://robodev.azurewebsites.net',
        };
    }
}
